module.exports = __webpack_public_path__ + "static/media/Drilling.6d37dc03.mp3";